const selector = {
  globalnav: {
    mountEl: '#js-globalnav-app',
    navEl: '.header-globalnav',
    productCategories: '#json-product-categories'
  }
}

export { selector }
